import React from 'react'
import ReactDOM from 'react-dom'

import { ApolloProvider, ApolloClient } from 'react-apollo'
import { createNetworkInterface } from 'apollo-upload-client'
import { LocaleProvider } from 'antd'
import thTH from 'antd/lib/locale-provider/th_TH'
import App from './App'
// import './index.css'

const networkInterface = createNetworkInterface({ uri: process.env.REACT_APP_API_URI })

const client = new ApolloClient({
  networkInterface
})

ReactDOM.render(
  <ApolloProvider client={client} >
    <LocaleProvider locale={thTH} >
      <App />
    </LocaleProvider>
  </ApolloProvider>
  ,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js